import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { searchOpinions } from '../../actions';

class SearchOpinions extends Component {
	constructor( props ) {
		super( props );
		this.state = {
			showSearch: true
		};
		this.toggleShowSearch = this.toggleShowSearch.bind( this );
	}

	handleFormSubmit( event ) {
		event.preventDefault();
	}

	handleSearch( event ) {
		this.props.searchOpinions( event.target.value );
	}

	toggleShowSearch() {
		this.setState( { showSearch: !this.state.showSearch } );
	}

	render() {
		return (<div>
				<div className="sidebar-heading-container">
					<h2 className="sidebar-heading">Keyword Filter</h2>
					<i className={ `fa-solid fa-chevron-${ this.state.showSearch
					                                       ? 'up'
					                                       : 'down' } filter-toggle-icon` }
					   onClick={ this.toggleShowSearch }></i>
				</div>
				{ this.state.showSearch && (<Fragment>
						<p className="sidebar-description">
							Please enter a keyword to filter the opinions.
						</p>
						{/*<label className="search-label"*/}
						{/*       htmlFor="opinions-inner-page-search">Keyword*/}
						{/*	Filter</label>*/}
						<input type="search"
						       value={ this.props.searchTerm }
						       onChange={ this.handleSearch.bind( this ) }
						       className="form-control"
						       id="opinions-inner-page-search"
						       placeholder="Filter by keyword"/>
					</Fragment>
				) }
			</div>
		);
	}
}

function mapStateToProps( { searchTerm } ) {
	return { searchTerm };
}

export default connect( mapStateToProps, {
	searchOpinions
} )( SearchOpinions );